/*$(document)
  .on("click.fui.listpanel.selected", ".table-select > tbody > tr", function () {
    const that = $(this)
    const sel = that.siblings(".selected")
    if (sel.length > 0) sel.removeClass("selected")

    if (that.hasClass("selected")) that.removeClass("selected")
    else that.addClass("selected")

  })
  .on("click.fui.listpanel.multiselected", ".table-multiselect > tbody > tr", function () {
    const that = $(this)
    if (that.hasClass("selected")) that.removeClass("selected")
    else that.addClass("selected")

  })*/


const getCookie = function (name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg))
    return unescape(arr[2]);
  else
    return null;
}

const setCookie = function (name, value) {
  var Days = 30;
  var exp = new Date();
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
  document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
}

/*const lan = getCookie("fuiLan")
if (!this.$lan) {
  const xlan = navigator.browserLanguage ? navigator.browserLanguage : navigator.language
  if (xlan.indexOf("zh") >= 0) this.$lan = "zh"
  else this.$lan = "en"
}*/
//$.fuiLan = const lan


//const trim = $.trim;
//const extend = $.extend;
const trim = function (string) {
  const reg = new RegExp('(^[\\s\\t\\xa0\\u3000]+)|([\\u3000\\xa0\\s\\t]+\x24)', 'g')
  return string.replace(reg, '')
}
const extend = (function () {
  const isObjFunc = function (name) {
    var toString = Object.prototype.toString
    return function () {
      return toString.call(arguments[0]) === '[object ' + name + ']'
    }
  }
  var isObject = isObjFunc('Object'),
    isArray = isObjFunc('Array'),
    isBoolean = isObjFunc('Boolean')
  return function extend() {
    var index = 0,
      isDeep = false,
      obj, copy, destination, source, i
    if (isBoolean(arguments[0])) {
      index = 1
      isDeep = arguments[0]
    }
    for (i = arguments.length - 1; i > index; i--) {
      destination = arguments[i - 1]
      source = arguments[i]
      if (isObject(source) || isArray(source)) {
        //console.log(source)
        for (var property in source) {
          obj = source[property]
          if (isDeep && (isObject(obj) || isArray(obj))) {
            copy = isObject(obj) ? {} : []
            var extended = extend(isDeep, copy, obj)
            destination[property] = extended
          } else {
            destination[property] = source[property]
          }
        }
      } else {
        destination = source
      }
    }
    return destination
  }
})()


const isNull = function (d) {
  if (!d) return true;
  if (typeof d == "string" && this.$trim(d) == "") return true;
  return false;
}


const dateNow = function (dt) {
  const d = new Date()
  if (dt) d.setDate(d.getDate() + dt)
  return d.Format("yyyy-MM-dd")
}

const strToDate = function (str, sep) {
  if (!sep) sep = "-"
  const dr = str.split(sep)
  return new Date(parseInt(dr[0]), parseInt(dr[1]) - 1, parseInt(dr[2]))
}


export default {
  dateNow,
  strToDate,
  isNull,
  extend,
  trim,
  setCookie,
  getCookie
}